import styled, { css } from 'styled-components';
const mobileAndRailCSS = css `
	font-family: Rubik;
	font-size: 14px;
	font-weight: normal;
	line-height: 1.43;
`;
const desktopCss = css `
	font-family: Rubik;
	font-size: 16px;
	font-weight: bold;
	line-height: 1.5;
`;
export default styled.p `
	font-stretch: normal;
	font-style: normal;
	text-align: left;
	margin: 0 0 14px !important;
	color: var(--theme-page-text-color, #3a3a3a);

	@media (mid-width: 320px) {
		${mobileAndRailCSS}
	}

	@media (min-width: 481px) {
		${desktopCss}
	}
`;
